/**
 * AuiStatsOverview — Responsive grid of StatCard children.
 *
 * Renders child nodes (expected to be StatCards) in a responsive grid
 * with dividers. Follows the shadcn-echarts demo StatsOverview pattern.
 *
 * Props:
 *   (none — uses child nodes for StatCards)
 */

import type { ReactNode } from 'react';
import type { AuiRendererProps } from '../../registry';

export function AuiStatsOverview({ children }: AuiRendererProps) {
  return (
    <section
      className="overflow-hidden rounded-xl border bg-card text-card-foreground"
      data-testid="aui-stats-overview"
    >
      <div className="grid grid-cols-1 divide-y sm:grid-cols-2 sm:divide-y-0 lg:grid-cols-4 [&>*:nth-child(n+3)]:sm:max-lg:border-t">
        {children as ReactNode}
      </div>
    </section>
  );
}
